import { faMessageLines } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonRouterOutlet } from "@ionic/react";
import React from "react";
import { Route } from "react-router-dom";
import { debug } from "../../../App";
import { ChannelFilterProvider } from "../../../contexts/ChannelFilterContext";
import { Channel } from "../Channel";
import { ChannelListUI } from "../components/ChannelListUI";
import { SupportRequestSent } from "../components/SupportRequestSent";
import { MessageSearch } from "../mobile/MessageSearch";

export const ChatDesktop = (props: any) => {
  return (
    <div className={"sendbird-chat-desktop"}>
      <ChannelFilterProvider>
        <ChannelListUI />
      </ChannelFilterProvider>

      <IonRouterOutlet id={"chat-desktop"}>
        <Route
          path="/chat"
          exact
          render={(props) => {
            debug("Rendering /chat in ChatDesktop");
            return (
              <div className={"sendbird-chat-home"}>
                <FontAwesomeIcon icon={faMessageLines} size={"8x"} />
              </div>
            );
          }}
        />

        <Route
          path="/chat/channels/:channelUrl/highlight/:highlightMessageId"
          render={(props) => {
            debug("AuthenticatedRouter", "chat (desktop)", "highlightMessageId", props);
            return <Channel {...props} />;
          }}
        />

        <Route
          path="/chat/channels/:channelUrl/settings"
          render={(props) => {
            debug("AuthenticatedRouter", "chat (desktop)", "settingsIsOpen", props);
            return <Channel settingsIsOpen={true} {...props} />;
          }}
        />

        <Route
          path="/chat/channels/:channelUrl/from-contact-us"
          exact
          render={(props) => {
            return (
              <>
                <SupportRequestSent />
                <Channel {...props} />
              </>
            );
          }}
        />

        <Route
          path="/chat/channels/:channelUrl/search"
          exact
          render={(props) => {
            return <MessageSearch {...props} />;
          }}
        />
      </IonRouterOutlet>
    </div>
  );
};
